import { GenericAPIResource, GenericElementResource } from "../generic-api.model";
import { ResourceSerializer as IResourceSerializer } from "../rest-resource.interface";
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs/internal/Observable';
import { RestResourceService } from '../rest-resource.service';
import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class SearchService extends RestResourceService {
  constructor(private http: HttpClient) {
    super(http, '/VestaPlusHelpAPI/api/Search/', new SearchkSerializer());
  }
  public searchContent(request:any): Observable<SearchResults[]> {
    let requestUrl = 'SearchLoginContent';
    return this.GetWithPost<SearchResults>(requestUrl, request);
  }
}

export class SearchResults extends GenericAPIResource {

  constructor(copyObj: SearchResults = null) {
    super();
    if (copyObj == null) {
      return;
    }
    this.Category = copyObj.Category;
    this.Highlight = copyObj.Highlight;
    this.SectionId = copyObj.SectionId;
    this.Tags = copyObj.Tags;
    this.Title = copyObj.Title;
    this.Url = copyObj.Url;
  }
  Category: string;
  Highlight: string;
  SectionId: string;
  Tags: string;
  Title: string;
  Url: string;
}
export class SearchkSerializer implements IResourceSerializer {
  fromJson(json) {
    let obj = new SearchResults(json);
    return obj;
  }

  toJson(resource) { return resource; }
}
